module.exports = __webpack_public_path__ + "static/img/wave_2.4f9f89c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/wave_2.jpg
// module id = J5vG
// module chunks = 1